import React, { useEffect, useState } from 'react';
import { useHistory } from "react-router-dom";
import stylesCoup from '../Shared/Css/Videos/Videos.module.css'

// const defaultEmpImageSrc = '/empImg/image_placeholder.png'
const defaultEmpVideoSrc = '/empImg/video_placeholder.png';
const defaultEmpVideoExcelSrc = '/empImg/excel_placeholder.png';
const defaultEmpVideoPdflSrc = '/empImg/pdf_placeholder.png';
const defaultEmpVideoTxtlSrc = '/empImg/text_placeholder.png';

const initialFieldValues = {
  empId: 0,
  empName: '',
  empSabun: '',
  empGicwi: '',
  empIpSaIl: '',
  empDesc: '',
  empImgName: '',
  empImageFile: null,
  empImageType: '',
  empImageSrc: defaultEmpVideoSrc,
};

function Videos(props) {
  const { addOrEdit, recordForEdit, setRecordForEdit, msg } = props;
  const [values, setValues] = useState(initialFieldValues);
  // const [imageType, setImageType] = useState(null);
  const [errors, setErrors] = useState({});
  const [vmsg, setVmsg] = useState(msg);

  //히스토리사용
  const history = useHistory();

  useEffect(() => {
    if (recordForEdit != null) {
      setValues(recordForEdit);
      setVmsg(null);
    }
  }, [recordForEdit]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    //바이트계산 입력제안
    var byte = 0;
    for (var i = 0; i < value.length; ++i) {
      // 기본 한글 2바이트 처리
      value.charCodeAt(i) > 127 ? (byte += 2) : byte++;
    }
    //
    if (name === 'empName') {
      if (byte <= 12) {
        setValues({
          ...values,
          [name]: value,
        });
      } else {
        alert('한글6글자 영문12자 입력이 가능합니다.');
      }
    } else if (name === 'empSabun') {
      if (byte <= 12) {
        setValues({
          ...values,
          [name]: value,
        });
      } else {
        alert('숫자12자 입력이 가능합니다.');
      }
    } else if (name === 'empGicwi') {
      if (byte <= 10) {
        setValues({
          ...values,
          [name]: value,
        });
      } else {
        alert('한글5자, 숫자10자 입력이 가능합니다.');
      }
    } else if (name === 'empIpSaIl') {
      if (byte <= 12) {
        setValues({
          ...values,
          [name]: value,
        });
      } else {
        alert('숫자12자 입력이 가능합니다.');
      }
    } else if (name === 'empDesc') {
      if (byte <= 22) {
        setValues({
          ...values,
          [name]: value,
        });
      } else {
        alert('한글12자 영문22자 입력이 가능합니다.');
      }
    }
    // console.log(byte);
    // console.log(values);
    // console.log(name);
  };

  const progressMag = () => {
    setVmsg('Uploading...');
    props.setProgress((prevState) => {
      return { ...prevState, started: true };
    });
  };

  const showPreview = (e) => {
    //  console.log(e.target.files[0].type)
    if (e.target.files && e.target.files[0]) {
      const empImageFile = e.target.files[0];
      const reader = new FileReader();
      reader.onload = (x) => {
        if (
          e.target.files[0].type === 'image/png' ||
          e.target.files[0].type === 'image/bmp' ||
          e.target.files[0].type === 'image/jpeg' ||
          e.target.files[0].type === 'image/gif'
        ) {
          progressMag();
          // setImageType(e.target.files[0].type);
          setValues({
            ...values,
            empImageFile,
            empImageType: e.target.files[0].type, //이미지타입
            empImageSrc: x.target.result,
          });
        } else if (e.target.files[0].type === 'video/mp4') {
          progressMag();
          // setImageType(e.target.files[0].type);
          setValues({
            ...values,
            empImageFile,
            empImageType: e.target.files[0].type, //이미지타입
            empImageSrc: x.target.result,
          });
        } else if (
          e.target.files[0].type ===
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        ) {
          progressMag();
          // setImageType(e.target.files[0].type);
          setValues({
            ...values,
            empImageFile,
            empImageType: e.target.files[0].type, //이미지타입
            empImageSrc: x.target.result,
          });
        } else if (e.target.files[0].type === 'application/pdf') {
          progressMag();
          // setImageType(e.target.files[0].type);
          setValues({
            ...values,
            empImageFile,
            empImageType: e.target.files[0].type, //이미지타입
            empImageSrc: x.target.result,
          });
        } else if (e.target.files[0].type === 'text/plain') {
          progressMag();
          // setImageType(e.target.files[0].type);
          setValues({
            ...values,
            empImageFile,
            empImageType: e.target.files[0].type, //이미지타입
            empImageSrc: x.target.result,
          });
        } else {
          alert('허용하지 않는 확장자 입니다.:' + e.target.files[0].type);
          cancelHandle();
        }
      };
      reader.readAsDataURL(empImageFile);
    } else {
      setValues({
        ...values,
        empImageFile: null,
        empImageType: '',
        empImageSrc: defaultEmpVideoSrc,
      });
    }
  };

  const validate = () => {
    let temp = {};
    temp.empName = values.empName === '' ? false : true;
    temp.empSabun = values.empSabun === '' ? false : true;
    temp.empGicwi = values.empGicwi === '' ? false : true;
    temp.empIpSaIl = values.empIpSaIl === '' ? false : true;
    temp.empImageSrc = values.empImageSrc === defaultEmpVideoSrc ? false : true;
    setErrors(temp);
    return Object.values(temp).every((x) => x === true);
  };

  //초기화
  const resetForm = (e) => {
    setValues(initialFieldValues);
    document.getElementById('image-uploader').value = null;
    setErrors({});
    setVmsg('');
  };

  //취소버튼
  const cancelHandle = () => {
    resetForm();
    props.setMsg("")
    setRecordForEdit(null)
    props.setProgress((prevState) => {
      return { ...prevState, started: false };
    });
  };

  const handlFormSubmit = (e) => {
    e.preventDefault();
    if (validate()) {
      const formData = new FormData();
      formData.append('empId', values.empId);
      formData.append('empName', values.empName);
      formData.append('empSabun', values.empSabun);
      formData.append('empGicwi', values.empGicwi);
      formData.append('empIpSaIl', values.empIpSaIl);
      formData.append('empDesc', values.empDesc);
      formData.append('empImgName', values.empImgName);
      formData.append('empImageFile', values.empImageFile);
      formData.append('empImageType', values.empImageType);
      addOrEdit(formData, resetForm);
      //저장후 초기화
      cancelHandle();
      setVmsg('정상적으로 저장되었습니다.');
    } else {
      alert('입력항목을 확인하세요');
    }
  };

  const applyErrorClass = (field) =>
    field in errors && errors[field] === false ? ' invalidField' : '';

  return (
    <>
      <div className={`container-sm ${stylesCoup.textCenterEmp}`}>
        <p className="lead"> 영상교육등록 </p>
      </div>
      <form autoComplete="off" noValidate onSubmit={handlFormSubmit}>
        <div className="card">
          <div className={`emp-imges-card ${stylesCoup.empHidden}`}>
            {values.empImageType === 'image/png' ? (
              <img
                src={values.empImageSrc}
                className={`mx-auto d-block rounded ${stylesCoup.empDBlock}`}
                alt=""
              />
            ) : values.empImageType === 'image/bmp' ? (
              <img
                src={values.empImageSrc}
                className={`mx-auto d-block rounded ${stylesCoup.empDBlock}`}
                alt=""
              />
            ) : values.empImageType === 'image/jpeg' ? (
              <img
                src={values.empImageSrc}
                className={`mx-auto d-block rounded ${stylesCoup.empDBlock}`}
                alt=""
              />
            ) : values.empImageType === 'image/gif' ? (
              <img
                src={values.empImageSrc}
                className={`mx-auto d-block rounded ${stylesCoup.empDBlock}`}
                alt=""
              />
            ) : values.empImageType === 'video/mp4' ? (
              <img
                src={defaultEmpVideoSrc}
                className={`mx-auto d-block rounded ${stylesCoup.empDBlock}`}
                alt=""
              />
            ) : values.empImageType ===
              'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ? (
              <img
                src={defaultEmpVideoExcelSrc}
                className={`mx-auto d-block rounded ${stylesCoup.empDBlock}`}
                alt=""
              />
            ) : values.empImageType === 'application/pdf' ? (
              <img
                src={defaultEmpVideoPdflSrc}
                className={`mx-auto d-block rounded ${stylesCoup.empDBlock}`}
                alt=""
              />
            ) : values.empImageType === 'text/plain' ? (
              <img
                src={defaultEmpVideoTxtlSrc}
                className={`mx-auto d-block rounded ${stylesCoup.empDBlock}`}
                alt=""
              />
            ) : (
              <img
                src={defaultEmpVideoSrc}
                className={`mx-auto d-block rounded ${stylesCoup.empDBlock}`}
                alt=""
              />
            )}
          </div>
          <div className={`card-body ${stylesCoup.cardBody}`}>
            <div className="form-group">
              <input
                type="file"
                accept="image/*, 
                        video/*,
                        application/vnd.ms-excel,
                        application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,
                        text/plain,
                        .pdf"
                className={'form-control-file' + applyErrorClass('empImageSrc')}
                onChange={showPreview}
                id="image-uploader"
              />
            </div>
            <div className="form-group text-center">
              <div>{vmsg}</div>
              {props.progress.started && (
                <progress
                  className={stylesCoup.progressSize}
                  max="100"
                  value={props.progress.pc}
                ></progress>
              )}
            </div>
            <div className={stylesCoup.empFormGroup}>
              <div className="form-group">
                <input
                  className={'form-control' + applyErrorClass('empName')}
                  style={{ height: '30px' }}
                  placeholder="영상교육명"
                  name="empName"
                  value={values.empName}
                  onChange={handleInputChange}
                />
              </div>
              <div className="form-group">
                <input
                  className={'form-control' + applyErrorClass('empSabun')}
                  type="number"
                  style={{ height: '30px' }}
                  placeholder="시리얼No"
                  name="empSabun"
                  value={values.empSabun}
                  onChange={handleInputChange}
                />
              </div>
            </div>
            <div className={stylesCoup.empFormGroup}>
              <div className="form-group">
                <input
                  className={'form-control' + applyErrorClass('empGicwi')}
                  style={{ height: '30px' }}
                  placeholder="평점"
                  name="empGicwi"
                  value={values.empGicwi}
                  onChange={handleInputChange}
                />
              </div>
              <div className="form-group">
                <input
                  className={'form-control' + applyErrorClass('empIpSaIl')}
                  style={{ height: '30px' }}
                  placeholder="일자[-없이]"
                  name="empIpSaIl"
                  value={values.empIpSaIl}
                  onChange={handleInputChange}
                />
              </div>
            </div>
            <div className={`form-group ${stylesCoup.empKita}`}>
              <input
                type="text"
                className="form-control"
                style={{ height: '30px' }}
                placeholder="영상교육기타"
                name="empDesc"
                value={values.empDesc}
                onChange={handleInputChange}
              />
            </div>
            <div className="form-group text-center">
              <button type="submit" className="btn btn-primary mt-3">
                실행
              </button>
              <button
                type="button"
                className="btn btn-info mt-3  ml-2 "
                onClick={cancelHandle}
              >
                취소
              </button>
              <button
                type="button"
                className="btn btn-warning mt-3  ml-2 "
                onClick={() => { history.goBack(); }}  //이게 더빠름
                // onClick={() => { window.location.href = '/home/index'; }}
              >
                나감
              </button>
            </div>
            <div style={{ textAlign: 'center' }}>{values.empImgName}</div>
          </div>
        </div>
      </form>
    </>
  );
}
export default Videos;
